import {useState} from "react"
import {postData} from "../util/Server"
import Endpoints from "../util/Endpoints"
import {ERROR, Notify, SUCCESS} from "../util/Notify"

const useAdminPayout = () => {
    const [isPayingOut, setIsPayingOut] = useState(false)

    const runPayout = (businessId, onSuccess) => {
        if (!businessId) return
        setIsPayingOut(true)
        const fd = new FormData()
        postData(Endpoints.ADMIN_PAYOUT_NOW(businessId), fd)
            .then(res => res.json())
            .then(res => {
                setIsPayingOut(false)
                if (res?.status === "dispatched") {
                    Notify("Payout dispatched", SUCCESS)
                    if (onSuccess) onSuccess(res)
                } else {
                    Notify(res?.error || res?.message || "Failed to run payout", ERROR)
                }
            })
            .catch(() => {
                setIsPayingOut(false)
                Notify("Failed to run payout", ERROR)
            })
    }

    return {isPayingOut, runPayout}
}

export default useAdminPayout
